import { Element } from "@siteimprove/alfa-dom";
import { Predicate } from "@siteimprove/alfa-predicate";
import { isRendered } from "../../node/predicate/is-rendered.js";
const { hasTabIndex, isActuallyDisabled } = Element;
const { and, not } = Predicate;
/**
 * {@link https://html.spec.whatwg.org/#focusable-area}
 *
 * @public
 */
export function isFocusable(device) {
    return and(hasTabIndex(), and(not(isActuallyDisabled), isRendered(device)));
}
//# sourceMappingURL=is-focusable.js.map